import { Spin } from "antd"
import { FC, useEffect, useState } from "react"
import { useGetLinkQuery, useGetMoreSectionTypesQuery } from "../../../../../graphql"
import LeftSide from "./components/LeftSide"
import RightSide from "./components/RightSide"
import "./index.less"

const ManageBlock: FC<ManageLinkBlockInterface> = ({ selectedLinkId }) => {
  const allRegions = ["Asia - Oceania", "Europe - Middle East - Africa", "North America"]
  const { data: moreSectionTypes } = useGetMoreSectionTypesQuery({
    fetchPolicy: "network-only",
    errorPolicy: "all",
    variables: { region: allRegions },
  })
  const { data: linkData, loading } = selectedLinkId
    ? useGetLinkQuery({
        fetchPolicy: "network-only",
        errorPolicy: "all",
        variables: {
          id: String(selectedLinkId),
        },
      })
    : { data: null, loading: false }
  const link = linkData?.appNewsPost?.data

  const [initialFilters, setInitialFilters] = useState<{ [key: string]: any }>()
  const [filters, setFilters] = useState<{ [key: string]: any }>()
  const types: SelectItems | undefined = moreSectionTypes?.appMoreSectionTypes?.data
    ?.filter(
      item =>
        item.attributes!.name !== "product_matchmaker" &&
        item.attributes!.name !== "events" &&
        item.attributes!.name !== "campaign_calculator" &&
        item.attributes!.name !== "km_tournament"
    )
    ?.map(item => ({
      value: item.attributes!.name!,
      label: item.attributes!.label!,
      key: String(item.id),
    }))

  useEffect(() => {
    if (types && ((selectedLinkId && link) || !selectedLinkId)) {
      const filters = {
        image: null,
        title: link?.attributes?.title || "",
        urlLink: link?.attributes?.link || "",
        description: link?.attributes?.body || "",
        currentImage: link?.attributes?.image?.data?.attributes?.url || "",
        type: link?.attributes?.more_section_type?.data?.attributes?.name || "",
      }
      setInitialFilters(filters)
      setFilters(filters)
    }
  }, [link, moreSectionTypes])

  const isChangesDisabled = !!(initialFilters?.title && !selectedLinkId)

  console.log({ filters, initialFilters, types, loading })

  return (
    <div className={`block-manage-wrapper ${loading && "center"}`}>
      {loading && <Spin className={"links-manage-block-spin"} />}

      {!loading && filters && initialFilters && types && (
        <>
          <LeftSide
            {...{
              link,
              types,
              filters,
              setFilters,
              initialFilters,
              selectedLinkId,
              isChangesDisabled,
              setInitialFilters,
            }}
          />
          <RightSide
            {...{
              link,
              types,
              filters,
              setFilters,
              isChangesDisabled,
            }}
          />
        </>
      )}
    </div>
  )
}

export default ManageBlock
